import { render } from "./ExportarMatrizes.vue?vue&type=template&id=f7f5ea9c"
import script from "./ExportarMatrizes.vue?vue&type=script&lang=js"
export * from "./ExportarMatrizes.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__